import qs from 'query-string'
import type { TagsSearchResponse } from '@zendesk/zqa-services/tickets'

import { api } from '@/api'

export const searchTicketTags = ({
  workspaceIds,
  tag,
  signal,
}: { workspaceIds: number[]; tag?: string } & { signal?: AbortSignal }) =>
  api
    .get('ticket/tags/prefix', {
      headers: { 'X-Klaus-Workspace': workspaceIds.join() },
      searchParams: qs.stringify({ tag, limit: 100 }),
      signal,
    })
    .json<TagsSearchResponse>()

export const searchAccountTicketTags = ({ tag, signal }: { tag?: string; signal?: AbortSignal }) =>
  api
    .get('ticket/account/tags/prefix', {
      searchParams: qs.stringify({ tag, limit: 100 }),
      signal,
    })
    .json<TagsSearchResponse>()
